import React from 'react';

export default function ShippingPage() {
  return (
    <div className="info-page">
      <p className="mono" style={{ color: 'var(--gold)', marginBottom: '8px' }}>SHIPPING</p>
      <h1>Shipping Info</h1>

      <h3>Flat Rate Shipping</h3>
      <p>All orders ship for a flat rate of <strong>$5.95</strong> via USPS.</p>

      <h3>Free Shipping</h3>
      <p>Orders over <strong>$80</strong> ship free. That's roughly a trophy pair plus a couple of add-ons.</p>

      <h3>Processing Time</h3>
      <p>Most orders ship within 3-5 business days. Every rack is 3D-printed to order — we don't keep pre-made stock sitting around.</p>

      <h3>Tracking</h3>
      <p>You'll get a tracking number by email once your order ships. You can also check your order status from your account page.</p>

      <h3>Where We Ship</h3>
      <p>Currently United States only. We're working on international shipping.</p>
    </div>
  );
}
